import LanguagePicker from './components/LanguagePicker'
import RegionSelector from './components/RegionSelector';
import './components/MagnetWireCalculator';
import SolutionsFilterBarSearch from './components/SolutionsFilterBarSearch';
import FilterBarSearch from './components/FilterBarSearch';

( function () {
// jQuery.noConflict();
    let MagnetWireCalculatorEl = document.getElementById( 'elDataGrid' );
    if ( MagnetWireCalculatorEl ) {
        window.onload = loadData( 0 );
    }


// jQuery(document).ready(function() {
//     jQuery('.solutions-spsx-taxonomy-filter').select2();
// });
// Filter Bar Search
    for ( const el of document.querySelectorAll( "#solutions-filter-bar" ) ) {
        let filterBar = new SolutionsFilterBarSearch( el );
    }
    for ( const el of document.querySelectorAll( "#tax-filter-bar" ) ) {
        let filterBar = new FilterBarSearch( el );
    }

// var wireScroll = function(e) {
//     var isMobile = window.matchMedia('(max-width: 768px)').matches;
//     var element = document.getElementById("single_build_content");
//
//     var scrollFunction = function() {
//         element.scrollIntoView({behavior: "smooth", block: "start", inline: "end"});
//     };
//
//     if(isMobile) {
//         document.getElementById("single_build").removeEventListener('click', scrollFunction, true);
//     } else {
//         document.getElementById("single_build").addEventListener('click', scrollFunction, true);
//     }
// };
//
// window.addEventListener('resize', wireScroll);

// Product Image Carousel
    let productCarouselEl = document.getElementsByClassName( 'product-slides' );
    if ( productCarouselEl.length ) {
        new Glide( '.product-slides', {
            autoplay: false,
            type: 'carousel',
            dots: '.glide__bullets',
            draggable: false,
            animationDuration: 500,
            animationTimingFunc: 'cubic-bezier(0.19, 1, 0.22, 1)',
            startAt: 0,
            perView: 1,
            gap: 0,
        } ).on( 'build.after', function () {
            const slideHeight = jQuery( '.glide__slide--active img' ).outerHeight();
            const glideTrack = jQuery( '.glide__track' ).outerHeight();
            console.log( slideHeight, glideTrack );
            if ( slideHeight !== glideTrack ) {
                let newHeight = slideHeight;
                jQuery( '.glide__track' ).css( 'height', newHeight );
            }
        } ).on( 'run.after', function () {
            const slideHeight = jQuery( '.glide__slide--active img' ).outerHeight();
            const glideTrack = jQuery( '.glide__track' ).outerHeight();
            if ( slideHeight !== glideTrack ) {
                let newHeight = slideHeight;
                jQuery( '.glide__track' ).css( 'height', newHeight );
            }
        } ).mount();
    }

    let regionSelectorEl = document.getElementById( 'modal-region-select' );
    if ( regionSelectorEl ) {
        window.products = new RegionSelector( regionSelectorEl );
    }

    for ( const el of document.querySelectorAll( ".language-selector" ) ) {
        let languagePicker = new LanguagePicker( el );
    }

//snippet for petal
    let default_content = document.getElementById( "default-content" )
    let default_bg = document.getElementById( "petal-default_bg" )
    let elms = document.getElementsByClassName( "petal-card" );
    let elms2 = document.getElementsByClassName( "right-inner_content" );
    let n = elms.length;
    let current = 0;
    let current2 = 0;
    let current_count = 0;

    function changeContent( color ) {
        for ( let i = 0; i < n; i++ ) {
            elms[ i ].style.backgroundColor = color;
        }
    }

    for ( let i = 0; i < n; i++ ) {
        elms[ i ].onmouseover = function () {
            const x = i + 1;
            if ( current_count > 0 ) {
                current.classList.remove( "show" );
                current2.classList.remove( "active" );
                elms2[ i + 1 ].classList.add( "show" );
                elms[ i ].classList.add( "active" );
                current_count = 1;
                default_bg.style.backgroundImage = 'url(/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered' + i + '.svg)';

            } else {
                default_content.style.display = "none";
                elms2[ i + 1 ].classList.add( "show" );
                elms[ i ].classList.add( "active" );
                current_count = 1;
                default_bg.style.backgroundImage = 'url(/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered' + i + '.svg)';
            }

        };
        elms[ i ].onmouseout = function () {
            current = elms2[ i + 1 ];
            current2 = elms[ i ];
        };
    }

//preload images
    function preloadImage( url, callback ) {
        var img = new Image();
        img.src = url;
        img.onload = callback;
    }

//callback images
    function preloadImages( urls, allImagesLoadedCallback ) {
        var loadedCounter = 0;
        var toBeLoadedNumber = urls.length;
        urls.forEach( function ( url ) {
            preloadImage( url, function () {
                loadedCounter++;
                console.log( 'Number of loaded images: ' + loadedCounter );
                if ( loadedCounter == toBeLoadedNumber ) {
                    allImagesLoadedCallback();
                }
            } );
        } );

        function preloadImage( url, anImageLoadedCallback ) {
            var img = new Image();
            img.onload = anImageLoadedCallback;
            img.src = url;
        }
    }

// Let's call it:
    preloadImages( [
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered0-old.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered1.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered2.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered3.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered4.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered5.svg',
        '/wp-content/themes/spsx-solutions/source/images/petals/SVG/hovered6.svg',
    ], function () {
        console.log( 'All images were loaded' );
    } );
} )();
